import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import { Skeleton } from 'src/common/';
import SearchProfile from './SearchProfile';
import { useQuery } from '@apollo/client';
import { GET_SEARCH_PROFILES } from '../queries';
import { ISearchProfile } from '../types';
import CreateSearchProfile from './CreateSearchProfile';

export const SearchProfiles: FC = () => {
  const { loading, data } = useQuery<{
    getSearchProfiles: ISearchProfile[];
  }>(GET_SEARCH_PROFILES);

  const profiles = useMemo(() => (data && data.getSearchProfiles) || [], [data]);
  const existingKeywords = useMemo(() => {
    const existingKeywordsSet = new Set(profiles.flatMap(profile => profile.terms.map(term => term.toLowerCase())));
    return Array.from(existingKeywordsSet);
  }, [profiles]);

  return (
    <>
      {loading ? (
        <Skeleton loading active />
      ) : (
        <div className={styles.contentInner}>
          {profiles && (
            <div className={styles.searchProfiles}>
              {profiles.map(data => (
                <SearchProfile
                  color={data.color}
                  key={data.id}
                  id={data.id}
                  terms={data.terms}
                  title={data.name}
                  existingKeywords={existingKeywords}
                />
              ))}
            </div>
          )}
          <CreateSearchProfile />
        </div>
      )}
    </>
  );
};

export default SearchProfiles;
